export const USER_VISIBILITY_SCOPE = Object.freeze({
    ORG: 1,
    ONLY_ME: 2,
});